import React, { useRef, useState, useEffect } from 'react';

import { Box, Alert, FormControl, Input, InputLabel, TextField, ButtonGroup, Button, FormHelperText } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';

import './OrderComponent.css';

const isEmpty = (value) => value?.trim() === '';

const getTomorrowsDate = () => {
  let tomorrow = new Date(); // Does this exemplifies the problem of mutability in javascript?
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow.toISOString();
}

const OrderComponent = (props) => {
  const [formInputsValidity, setFormInputsValidity] = useState({
    police_name: true,
    number: true,
    cui: true,
    order_type: true,
    observation: true
  });
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  useEffect(() => {
    if (showSuccessAlert) {
      setTimeout(() => {
        setShowSuccessAlert(false)
      }, 3000);
    }

    if (showErrorAlert) {
      setTimeout(() => {
        setShowErrorAlert(false)
      }, 3000);
    }
  }, [showSuccessAlert, showErrorAlert])

  const formRef = useRef();
  const policeNameInputRef = useRef();
  const numberInputRef = useRef();
  const cuiInputRef = useRef();
  const orderTypeInputRef = useRef();
  const observationInputRef = useRef();
  const remainderRef = useRef();

  const saveHandler = async (event) => {
    event.preventDefault();

    const enteredPoliceName = policeNameInputRef.current.value;
    const enteredNumber = numberInputRef.current.value;
    const enteredCUI = cuiInputRef.current.value;
    const enteredOrderType = orderTypeInputRef.current.value;
    const enteredObservation = observationInputRef.current.value;
    const enteredRemainder = remainderRef.current.value;

    const enteredPoliceNameIsValid = !isEmpty(enteredPoliceName);
    const enteredNumberIsValid = !isEmpty(enteredNumber);
    const enteredCUIIsValid = !isEmpty(enteredCUI);
    const enteredOrderTypeIsValid = !isEmpty(enteredOrderType);
    const enteredObservationIsValid = !isEmpty(enteredObservation);

    setFormInputsValidity({
      police_name: enteredPoliceNameIsValid,
      number: enteredNumberIsValid,
      cui: enteredCUIIsValid,
      order_type: enteredOrderTypeIsValid,
      observation: enteredObservationIsValid
    });

    const formIsValid =
      enteredPoliceNameIsValid &&
      enteredNumberIsValid &&
      enteredCUIIsValid &&
      enteredOrderTypeIsValid &&
      enteredObservationIsValid

    if (!formIsValid) {
      return;
    }

    let payload = {
      police_name: enteredPoliceName,
      number: enteredNumber,
      cui: enteredCUI,
      order_type: enteredOrderType,
      observation: enteredObservation,
    }
    if (!!enteredRemainder) {
      payload['remainders_attributes'] = [{ target_date: enteredRemainder }]
    }

    const rest = await props.onSave(payload);

    if (rest[0]) {
      setShowSuccessAlert(true)
    } else {
      // TODO: Set errors in the form and change its messages
      // var params = {};
      // for (let key in rest[1]) {
      //   params[key] = true
      // }

      setShowErrorAlert(true)      
      // setFormInputsValidity(params);
    }
  };

  const deleteHandler = (event) => {
    event.preventDefault();

    formRef.current.reset();
  };

  return (
    <Box
      component="form"
      sx={{
        '& > :not(style)': { m: 1 },
      }}
      noValidate
      autoComplete="off"
      ref={formRef}
    >
      {showErrorAlert && <Alert severity="error">Error!</Alert>}
      {showSuccessAlert && <Alert severity="success">Éxito!</Alert>}
      <h3>Formulario de Ingreso</h3>
      <div>
        <FormControl error={!formInputsValidity.police_name} variant="standard">
          <InputLabel htmlFor="police_name" className='input'>Nombre Policía</InputLabel>
          <Input id="police_name" inputRef={policeNameInputRef} className='input' />
          {!formInputsValidity.police_name && <FormHelperText>Por favor ingresa un Nombre de Policía valido!</FormHelperText>}
        </FormControl>

        <FormControl error={!formInputsValidity.number} variant="standard">
          <InputLabel htmlFor="number" className='input'>Número</InputLabel>
          <Input id="number" inputRef={numberInputRef} className='input' />
          {!formInputsValidity.number && <FormHelperText>Por favor ingresa un número valido!</FormHelperText>}
        </FormControl>

        <FormControl error={!formInputsValidity.cui} variant="standard">
          <InputLabel htmlFor="cui" className='input'>CUI</InputLabel>
          <Input id="cui" inputRef={cuiInputRef} className='input' />
          {!formInputsValidity.cui && <FormHelperText>Por favor ingresa un CUI valido!</FormHelperText>}
        </FormControl>

        <FormControl error={!formInputsValidity.order_type} variant="standard">
          <InputLabel htmlFor="order_type" className='input'>Tipo de Orden</InputLabel>
          <Input id="order_type" inputRef={orderTypeInputRef} defaultValue='Judicial' className='input' />
          {!formInputsValidity.order_type && <FormHelperText>Por favor ingresa un Tipo de Orden valido!</FormHelperText>}
        </FormControl>

        <FormControl error={!formInputsValidity.observation} variant="standard">
          <InputLabel htmlFor="observation" className='input'>Observación</InputLabel>
          <Input id="observation" inputRef={observationInputRef} defaultValue='N/A' className='input' />
          {!formInputsValidity.observation && <FormHelperText>Por favor ingresa una Observación valida!</FormHelperText>}
        </FormControl>
      </div>
      <div className='remainders-row'>
        <TextField
          id="remainder"
          inputRef={remainderRef}
          label="Recordatorio"
          type="date" // datetime-local
          // defaultValue="2017-05-24" // defaultValue="2017-05-24T10:30"
          sx={{ width: 220 }}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            // only needs the first 10 characters in the date string
            min: getTomorrowsDate().slice(0, 10)
          }}
        />
      </div>
      <ButtonGroup variant="">
        <Button variant="contained" startIcon={<DeleteIcon />} sx={{ marginRight: 2 }} onClick={deleteHandler}>DELETE</Button>
        <Button variant="contained" startIcon={<SaveIcon />} sx={{ marginRight: 2 }} onClick={saveHandler}>SAVE</Button>
      </ButtonGroup>
    </Box>
  );
};

export default OrderComponent;